/**
 * Tool to manage the loading states of buttons
 * Manages the aria-disabled and aria-hidden attributes for buttons, texts and loaders
 */
export class ButtonLoader {
  /**
   * Set the loading state of a button
   * @param {HTMLElement|null} button - The button to control
   * @param {HTMLElement|null} textElement - The text element to hide/show
   * @param {HTMLElement|null} loaderElement - The loader element to hide/show
   * @param {boolean} isLoading - true to activate the loading, false to deactivate the loading
   */
  static setLoading(button, textElement, loaderElement, isLoading) {
    if (isLoading) {
      button?.setAttribute('aria-disabled', 'true');
      textElement?.setAttribute('aria-hidden', 'true');
      loaderElement?.removeAttribute('aria-hidden');
    } else {
      button?.setAttribute('aria-disabled', 'false');
      textElement?.removeAttribute('aria-hidden');
      loaderElement?.setAttribute('aria-hidden', 'true');
    }
  }

  /**
   * Toggle the loading state of a button
   * @param {HTMLElement|null} button - The button to control
   * @param {HTMLElement|null} textElement - The text element to hide/show
   * @param {HTMLElement|null} loaderElement - The loader element to hide/show
   * @returns {boolean} The new loading state (true if loading is activated, false otherwise)
   */
  static toggleLoading(button, textElement, loaderElement) {
    const isCurrentlyLoading = button?.getAttribute('aria-disabled') === 'true';
    const newLoadingState = !isCurrentlyLoading;
    this.setLoading(button, textElement, loaderElement, newLoadingState);
    return newLoadingState;
  }
}
